module.exports = __webpack_public_path__ + "static/media/theta.a505f47e.svg";